import HeroSection from '@/components/HeroSection'
import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'
import Link from 'next/link'

const aboutSections = [
  { label: 'Inspiration', href: '/about/inspiration' },
  { label: 'Mission', href: '/about/mission' },
  { label: 'Vision', href: '/about/vision' },
  { label: 'Bio', href: '/about/bio' },
  { label: 'Core Values', href: '/about/core-values' },
  { label: 'Contact', href: '/about/contact' },
]

export default function AboutInspiration() {
  const inspirations = [
    {
      id: '1',
      title: 'A Doctor Of The People: Hani Alfifai',
      image: '/story-event.jpg',
      date: '24/08/2024',
      category: 'Stories',
      likes: 23,
      comments: 0,
    },
    {
      id: '2',
      title: 'Homs Was More Than Just A Place; It Was A Home',
      image: '/blog-homs.jpg',
      date: '24/08/2024',
      category: 'Stories',
      likes: 23,
      comments: 0,
    },
    {
      id: '3',
      title: 'Inspired By Steve Jobs: A Syrian Connection',
      image: '/blog-steve-jobs.jpg',
      date: '24/08/2024',
      category: 'Stories',
      likes: 23,
      comments: 0,
    },
  ]

  const blogPosts = [
    {
      id: '1',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: '/ghassan-profile.jpg',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
    {
      id: '2',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: '/investment-wealth.jpg',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
    {
      id: '3',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: '/ghassan-real.jpg',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
  ]

  return (
    <>
      {/* Hero */}
      <HeroSection
        title="INSPIRATION"
        imageUrl="/story-event.jpg"
      />

      {/* About Navigation */}
      <section className="py-8 bg-background border-b border-border">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap gap-4 justify-center md:justify-start">
            {aboutSections.map((section) => (
              <Link
                key={section.href}
                href={section.href}
                className={`px-4 py-2 rounded font-medium transition-colors ${
                  section.href === '/about/inspiration'
                    ? 'bg-accent text-accent-foreground'
                    : 'text-foreground hover:text-accent'
                }`}
              >
                {section.label}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Search and Filter */}
      <section className="py-12 bg-background">
        <div className="container mx-auto px-4">
          <div className="max-w-md">
            <input
              type="search"
              placeholder="Search"
              className="w-full px-4 py-2 bg-input border border-border rounded text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-accent"
            />
          </div>

          <div className="mt-8">
            <h3 className="font-semibold text-foreground mb-4">All Categories</h3>
            <div className="space-y-2 text-sm text-muted-foreground">
              <label className="flex items-center gap-2 cursor-pointer hover:text-foreground">
                <input type="checkbox" className="rounded" />
                Family <span className="text-accent">0</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer hover:text-foreground">
                <input type="checkbox" className="rounded" />
                Work <span className="text-accent">0</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer hover:text-foreground">
                <input type="checkbox" className="rounded" />
                Coming Soon Projects <span className="text-accent">5</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer hover:text-foreground">
                <input type="checkbox" className="rounded" />
                Current Projects <span className="text-accent">3</span>
              </label>
            </div>
          </div>

          <div className="mt-8">
            <h3 className="font-semibold text-foreground mb-4">Popular News</h3>
            <div className="space-y-4">
              {inspirations.slice(0, 2).map((post) => (
                <div key={post.id} className="flex gap-3 pb-4 border-b border-border">
                  <img src={post.image} alt={post.title} className="w-20 h-20 rounded object-cover" />
                  <div className="flex-1">
                    <p className="font-medium text-foreground text-sm line-clamp-2 hover:text-accent cursor-pointer">
                      {post.title}
                    </p>
                    <p className="text-xs text-muted-foreground mt-1">{post.date}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-8">
            <h3 className="font-semibold text-foreground mb-4">Photo Gallery</h3>
            <div className="space-y-2 text-sm text-muted-foreground">
              <label className="flex items-center gap-2 cursor-pointer hover:text-foreground">
                <input type="checkbox" className="rounded" />
                Gallery
              </label>
              <label className="flex items-center gap-2 cursor-pointer hover:text-foreground">
                <input type="checkbox" className="rounded" />
                Shopping
              </label>
              <label className="flex items-center gap-2 cursor-pointer hover:text-foreground">
                <input type="checkbox" className="rounded" />
                Traveling
              </label>
            </div>
          </div>

          <div className="mt-8">
            <h3 className="font-semibold text-foreground mb-3">Popular Tags</h3>
            <div className="flex flex-wrap gap-2">
              {['un tag', 'channel', 'home'].map((tag) => (
                <button
                  key={tag}
                  className="px-3 py-1 bg-secondary text-foreground rounded text-xs hover:bg-accent hover:text-accent-foreground transition-colors"
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Grid */}
      <section className="py-12 bg-background">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            {inspirations.map((post) => (
              <BlogCard key={post.id} {...post} />
            ))}
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-20 bg-secondary">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-foreground mb-2 text-center">
            From His Blog
          </h2>
          <p className="text-center text-muted-foreground mb-12">
            Dive Into The Blog For The Latest Updates, Expert Opinions, And Detailed Information On Our Projects.
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <BlogCard key={post.id} {...post} />
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <NewsletterSection />
    </>
  )
}
